export const defaultGradient =
  "linear-gradient(135deg, rgba(16,150,189,1) 0%, rgba(19,214,133,1) 100%)";
